import React from "react";
import { Navigate, ScrollRestoration } from "react-router-dom";

import { useAuth } from "context/AuthContext";
import UnAuthorized from "pages/error.pages/UnAuthorized";
import PathConstants from "./pathConstants";

const restoreScroll = () => {
  return <ScrollRestoration />;
};

export const ProtectedRoute = ({ children }) => {
  const { accessToken, loginType } = useAuth();

  restoreScroll();

  if (!accessToken) {
    return <Navigate to={PathConstants.LOGIN} replace={true} />;
  }
  if (!loginType) return children;
  else return <UnAuthorized />;
};

export const OfficialsRoute = ({ children }) => {
  const { accessToken, loginType } = useAuth();

  restoreScroll();

  if (!accessToken) {
    return <Navigate to={PathConstants.LOGIN} replace={true} />;
  }

  if (loginType === "nagar_nigam") return children;
  else return <UnAuthorized />;
};

export const SharedProtectedRoute = ({ children }) => {
  const { accessToken } = useAuth();

  restoreScroll();

  if (!accessToken) {
    return <Navigate to={PathConstants.LOGIN} replace={true} />;
  }

  return children;
};

export const JalkalRoute = ({ children }) => {
  const { accessToken, loginType } = useAuth();

  restoreScroll();

  if (!accessToken) {
    return <Navigate to={PathConstants.LOGIN} replace={true} />;
  }

  if (loginType === "jalkal") return children;
  else return <UnAuthorized />;
};
